import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as resources from "../../constants/resources";
import * as rcc from "../../constants/rcc";
import * as resultCodes from "../../constants/resultCodes";
import * as settings from "../../constants/settings";
import * as formulaActions from "../../actions/formulaActions";
import * as getterHelper from "../../helpers/getterHelper";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";
import * as responseHelper from "../../helpers/responseHelper";
import * as windowService from "../windowService";

const getFilterSearchPanelActions = (tabId, refresh) => {
    if (refresh === null) {
        return [];
    }

    if (refresh === actionTypes.SELECT_BIPP) {
        return [
            {
                type: actionTypes.FILTER_PRODUCT_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            },
            {
                type: actionTypes.FILTER_FANDECK_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            },
            {
                type: actionTypes.FILTER_FORMULA_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            },
            {
                type: actionTypes.FILTER_BASE_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            }
        ];
    }

    if (refresh === actionTypes.SELECT_BASE) {
        return [
            {
                type: actionTypes.FILTER_PRODUCT_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            },
            {
                type: actionTypes.FILTER_FANDECK_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            },
            {
                type: actionTypes.FILTER_FORMULA_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            },
            {
                type: actionTypes.FILTER_BIPP_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            }
        ];
    }

    if (refresh === actionTypes.SELECT_FANDECK) {
        return [
            {
                type: actionTypes.FILTER_PRODUCT_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            },
            {
                type: actionTypes.FILTER_FORMULA_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            },
            {
                type: actionTypes.FILTER_BASE_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            },
            {
                type: actionTypes.FILTER_BIPP_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            }
        ];
    }

    if (refresh === actionTypes.SELECT_PRODUCT) {
        return [
            {
                type: actionTypes.FILTER_FANDECK_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            },
            {
                type: actionTypes.FILTER_FORMULA_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            },
            {
                type: actionTypes.FILTER_BASE_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            },
            {
                type: actionTypes.FILTER_BIPP_LIST,
                payload: {
                    tabId: tabId,
                    autoselect: false
                }
            }
        ];
    }

    return [
        {
            type: actionTypes.FILTER_PRODUCT_LIST,
            payload: {
                tabId: tabId,
                autoselect: false
            }
        },
        {
            type: actionTypes.FILTER_FANDECK_LIST,
            payload: {
                tabId: tabId,
                autoselect: false
            }
        },
        {
            type: actionTypes.FILTER_BASE_LIST,
            payload: {
                tabId: tabId,
                autoselect: false
            }
        },
        {
            type: actionTypes.FILTER_BIPP_LIST,
            payload: {
                tabId: tabId,
                autoselect: false
            }
        }
    ];
};

const processInvalidCalculatedFormulaResponse = (tabId, method, response, refresh, fandeck, color) => {
    let filterActions = getFilterSearchPanelActions(tabId, refresh);

    filterActions.push({
        type: actionTypes.SAVE_FORMULA_DATA,
        payload: {
            tabId: tabId,
            navigation: false,
            formula: null,
            moreInfoText: null,
            moreInfoData: null,
            base: null,
            bipp: null,
            packageList: [],
            package: null,
            margin: null,
            validation: null
        }
    });

    if (
        method === handlers.GET_CALCULATED_FORMULA_FOR_COLOR_SEARCH &&
        response.data === undefined &&
        fandeck !== null &&
        color !== null
    ) {
        return [
            ...filterActions,
            {
                type: actionTypes.SERVER_REQUEST,
                payload: {
                    type: methods.METHOD_GET_COLOR_IN_FANDECK_DATA,
                    params: {
                        colorId: color.id,
                        fandeckId: fandeck.id,
                        isLocal: color.local
                    }
                },
                method: handlers.GET_FORMULA_CIF_DATA,
                tabId: tabId
            }
        ];
    }

    if (response.result === resultCodes.RESULT_UNKNOWN_ERROR) {
        return [messageHelper.getWarningMessageAction("flashMessage.formulaDataUnavailable"), ...filterActions];
    }

    return [messageHelper.getInvalidFormatMessage(response), ...filterActions];
};

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.GET_CALCULATED_FORMULA:
        case handlers.SEARCH_PANEL_GET_CALCULATED_FORMULA:
        case handlers.NAVIGATION_GET_CALCULATED_FORMULA:
        case handlers.GET_CALCULATED_FORMULA_FOR_COLOR_SEARCH:
            if (state.formula[tabId] === undefined) {
                windowService.logDebug(
                    "Formula tab (" + tabId + ") was closed before calculated formula request was finished."
                );

                return [];
            }

            if (!responseHelper.isGetCalculatedFormulaFormatValid(response)) {
                return processInvalidCalculatedFormulaResponse(
                    tabId,
                    method,
                    response,
                    state.searchPanel[tabId] === undefined ? null : state.searchPanel[tabId].refresh,
                    state.formula[tabId].fandeck,
                    state.formula[tabId].color
                );
            }

            if (
                state.formula[tabId].product === null ||
                state.formula[tabId].fandeck === null ||
                state.formula[tabId].color === null
            ) {
                return [];
            }

            let calculatedFormula = modelHelper.buildCalculatedFormulaObject(
                response.data.color,
                response.data.isLocal,
                response.data.formula,
                state.settings.shotsName,
                state.global.colorantList,
                state.settings.colorantPanelOrderBy,
                response.data.formulaCombination.id
            );
            let calculatedBase = modelHelper.mapBaseToObject(response.data.base, response.data.baseInProduct);
            let calculatedBipp = modelHelper.mapBaseInProductPackageToObject(response.data.package);
            let calculatedPackageList = modelHelper.mapBippToObjects(response.data.packages);
            let calculatedPackage =
                calculatedPackageList.length > 0 && response.data.package !== null
                    ? getterHelper.getObjectById(calculatedPackageList, response.data.package.id)
                    : null;
            let calculatedMargin = getterHelper.getDefaultMargin(
                state.global.allMarginList,
                state.pricing.showMargin,
                state.pricing.showMarkup,
                state.pricing.showDiscount
            );

            let responseActions = [
                {
                    type: actionTypes.SAVE_FORMULA_DATA,
                    payload: {
                        tabId: tabId,
                        navigation: method === handlers.NAVIGATION_GET_CALCULATED_FORMULA,
                        formula: calculatedFormula,
                        moreInfoText: responseHelper.getFormattedMoreInfo(response.data.formula),
                        moreInfoData: modelHelper.mapFormulaMoreInfoToObjects(response.data.formula),
                        base: calculatedBase,
                        bipp: calculatedBipp,
                        packageList: calculatedPackageList,
                        package: calculatedPackage,
                        margin: calculatedMargin,
                        validation: modelHelper.mapFormulaValidationErrorsToObject(
                            [],
                            rcc.RCC_VALIDATION_OK,
                            state.settings.validateTotalCntAmounts,
                            state.settings.validateOverfill,
                            state.settings.validateMinDosableAmount,
                            state.settings.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED,
                            state.settings.validateColorantBaseRules,
                            state.settings.colorantBatchForMultipleCans
                        )
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_COLOR_IN_FANDECK,
                        params: {
                            fandeckId: state.formula[tabId].fandeck.id,
                            colorId: state.formula[tabId].color.id,
                            isLocal: state.formula[tabId].color.local
                        }
                    },
                    method: handlers.GET_FORMULA_CIF,
                    tabId: tabId
                },
                {
                    type: actionTypes.MACHINE_VALIDATE_DISPENSED_FORMULA,
                    payload: {
                        tabId: tabId,
                        formula: calculatedFormula.getColorantVolumes(),
                        numCanDone: 0,
                        numCanTotal: state.formula[tabId].numCanTotal,
                        customCan: state.formula[tabId].package?.isCustom() ?? false
                    }
                }
            ];

            if (method === handlers.GET_CALCULATED_FORMULA_FOR_COLOR_SEARCH) {
                responseActions.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_COLOR_IN_FANDECK_DATA,
                        params: {
                            colorId: state.formula[tabId].color.id,
                            fandeckId: state.formula[tabId].fandeck.id,
                            isLocal: state.formula[tabId].color.local
                        }
                    },
                    method: handlers.GET_FORMULA_CIF_DATA,
                    tabId: tabId
                });
            }

            let invalidColorantList = getterHelper.getInvalidCalculatedFormulaColorants(
                response.data.formula.colorants,
                state.global.colorantList
            );

            if (invalidColorantList.length > 0) {
                responseActions.push(messageHelper.getWarningMessageAction("flashMessage.invalidFormulaColorants"));

                windowService.logInfo("Response data  : " + JSON.stringify(response.data));
                windowService.logInfo(
                    "Selected formula contains invalid colorants: " + invalidColorantList.join(", ") + "."
                );
                windowService.logInfo(
                    "Available colorants: " + state.global.colorantList.map((c) => c.name).join(", ") + "."
                );
            }

            if ((response.data.hasAlternatives || response.data.hasHistory) && !calculatedFormula.notAvailable) {
                responseActions.push(
                    formulaActions.getAvailableFormulas(
                        tabId,
                        state.formula[tabId].product.id,
                        state.formula[tabId].fandeck.id,
                        state.formula[tabId].color.id,
                        state.settings.searchPanelBase && calculatedBase !== null ? calculatedBase.id : null,
                        state.formula[tabId].color.local,
                        response.data.hasHistory,
                        response.data.hasAlternatives,
                        state.settings.tintometricSystemsEnabled,
                        state.settings.searchPanelBase
                    )
                );
            }

            return responseActions;
        case handlers.RECALCULATE_FORMULA:
        case handlers.INTERGAMMA_RECALCULATE_FORMULA:
            if (!responseHelper.isRecalculateFormulaFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let colorantListMl = modelHelper.getColorantListFromFormula(
                response.data.colorantAmountsByUnits.ml,
                state.global.allColorantList,
                settings.UNIT_ML,
                state.settings.colorantPanelOrderBy
            );
            let colorantListG = modelHelper.getColorantListFromFormula(
                response.data.colorantAmountsByUnits.g,
                state.global.allColorantList,
                settings.UNIT_G,
                state.settings.colorantPanelOrderBy
            );
            let colorantListShot = modelHelper.getColorantListFromFormula(
                response.data.colorantAmountsByUnits.shots,
                state.global.allColorantList,
                state.settings.shotsName,
                state.settings.colorantPanelOrderBy
            );

            if (method === handlers.INTERGAMMA_RECALCULATE_FORMULA) {
                return [
                    {
                        type: actionTypes.INTERGAMMA_SAVE_COLOR_DATA,
                        payload: {
                            colorantListMl: colorantListMl,
                            colorantListG: colorantListG,
                            colorantListShot: colorantListShot
                        }
                    }
                ];
            }

            let recalculateRequest = state.server.requests.find((request) => request.id === response.sequence);

            if (recalculateRequest !== undefined && recalculateRequest.next !== null) {
                return [
                    {
                        type: actionTypes.MAIN_TAB_SAVE_STANDARD_FORMULA_COLORANTS,
                        payload: {
                            tabId: tabId,
                            colorantListMl: colorantListMl,
                            colorantListG: colorantListG,
                            colorantListShot: colorantListShot,
                            fillingMl: response.data.baseFillVolumeMl
                        }
                    },
                    recalculateRequest.next
                ];
            }

            return [
                {
                    type: actionTypes.MAIN_TAB_SAVE_FORMULA_COLORANTS,
                    payload: {
                        tabId: tabId,
                        colorantListMl: colorantListMl,
                        colorantListG: colorantListG,
                        colorantListShot: colorantListShot,
                        fillingMl: response.data.baseFillVolumeMl
                    }
                },
                {
                    type: actionTypes.RELOAD_FORMULA_META_DATA,
                    payload: {
                        tabId: tabId
                    }
                }
            ];
        case handlers.RECALCULATE_MODIFIED_FORMULA:
            if (!responseHelper.isRecalculateFormulaFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.MAIN_TAB_SAVE_MODIFIED_FORMULA_COLORANTS,
                    payload: {
                        tabId: tabId,
                        colorantListMl: modelHelper.getColorantListFromFormula(
                            response.data.colorantAmountsByUnits.ml,
                            state.global.allColorantList,
                            settings.UNIT_ML,
                            state.settings.colorantPanelOrderBy
                        ),
                        colorantListG: modelHelper.getColorantListFromFormula(
                            response.data.colorantAmountsByUnits.g,
                            state.global.allColorantList,
                            settings.UNIT_G,
                            state.settings.colorantPanelOrderBy
                        ),
                        colorantListShot: modelHelper.getColorantListFromFormula(
                            response.data.colorantAmountsByUnits.shots,
                            state.global.allColorantList,
                            state.settings.shotsName,
                            state.settings.colorantPanelOrderBy
                        )
                    }
                },
                {
                    type: actionTypes.RELOAD_FORMULA_META_DATA,
                    payload: {
                        tabId: tabId
                    }
                }
            ];
        case handlers.GET_AVAILABLE_FORMULAS:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let available = state.server.requests.find((request) => request.id === response.sequence);

            if (available === undefined) {
                return [];
            }

            let listOfAlternativeFormulas = [];
            let listOfHistoricalFormulas = [];

            for (let item of modelHelper.mapHistoricalFormulas(
                response.data,
                state.settings.shotsName,
                state.global.allColorantList,
                state.settings.colorantPanelOrderBy
            )) {
                if (item.historical || !state.settings.tintometricSystemsEnabled || !available.next.hasAlternatives) {
                    listOfHistoricalFormulas.push(item);
                }

                if (!item.historical && state.settings.tintometricSystemsEnabled) {
                    listOfAlternativeFormulas.push(item);
                }
            }

            return [
                {
                    type: actionTypes.SAVE_ALTERNATIVE_FORMULAS,
                    payload: {
                        tabId: tabId,
                        formulaList: available.next.hasAlternatives ? listOfAlternativeFormulas : null
                    }
                },
                {
                    type: actionTypes.SAVE_HISTORICAL_FORMULAS,
                    payload: {
                        tabId: tabId,
                        formulaList: available.next.hasHistory ? listOfHistoricalFormulas : null
                    }
                }
            ];
        case handlers.GET_FORMULA_META_AND_PRINT_DATA:
        case handlers.GET_FORMULA_META_AND_PRINT_DATA_WITH_UFI:
        case handlers.NAVIGATION_GET_FORMULA_META_AND_PRINT_DATA:
            if (!responseHelper.isGetFormulaMetaData2FormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let formulaValidation = modelHelper.mapFormulaValidationErrorsToObject(
                response.data.formulaValidationErrors,
                state.formula[tabId] !== undefined && state.formula[tabId].formula !== null
                    ? state.formula[tabId].formula.validationAll
                    : rcc.RCC_VALIDATION_OK,
                state.settings.validateTotalCntAmounts,
                state.settings.validateOverfill,
                state.settings.validateMinDosableAmount,
                state.settings.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED,
                state.settings.validateColorantBaseRules,
                state.settings.colorantBatchForMultipleCans
            );

            let metaActions = [
                {
                    type: actionTypes.SAVE_FORMULA_META_AND_PRINT_DATA,
                    payload: {
                        tabId: tabId,
                        priceList: response.data.priceList === null ? [] : response.data.priceList,
                        printData: response.data.printData,
                        tmcData: response.data.tmcData,
                        infoData: response.data.infoData,
                        productFiles: response.data.productFiles,
                        validation: formulaValidation,
                        customPackageAmounts: response.data.customPackageAmounts
                    }
                }
            ];

            if (
                method === handlers.GET_FORMULA_META_AND_PRINT_DATA &&
                state.settings.searchPanelQuickSelect &&
                state.navigation.tabList.some((tab) => tab.id === tabId && tab.type === componentTypes.INITIAL_TAB)
            ) {
                metaActions.push({
                    type: actionTypes.ADD_NEW_MAIN_TAB,
                    payload: {
                        tabId: tabId,
                        color: state.formula[tabId].color
                    }
                });
            }

            if (method === handlers.NAVIGATION_GET_FORMULA_META_AND_PRINT_DATA) {
                metaActions.push({
                    type: actionTypes.NAVIGATION_AFTER_SAVE_FORMULA_DATA,
                    payload: {
                        tabId: tabId
                    }
                });
            }

            if (method === handlers.GET_FORMULA_META_AND_PRINT_DATA_WITH_UFI) {
                metaActions.push({
                    type: actionTypes.RELOAD_DISPENSING_FORMULA_META_DATA,
                    payload: {
                        priceList: response.data.priceList === null ? [] : response.data.priceList,
                        printData: response.data.printData,
                        tmcData: response.data.tmcData,
                        infoData: response.data.infoData
                    }
                });

                if (state.rcc.machine.dialog !== null) {
                    metaActions.push({
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_DIALOG_BUTTON_CLICK,
                            params: {
                                dialogID: state.rcc.machine.dialog.id,
                                msgBtn: rcc.RCC_BTN_CONTINUE
                            }
                        },
                        method: handlers.MACHINE_DIALOG_BUTTON_CLICK,
                        tabId: 0,
                        safe: false
                    });
                }
            }

            return metaActions.concat(
                getFilterSearchPanelActions(
                    tabId,
                    state.searchPanel[tabId] === undefined ? null : state.searchPanel[tabId].refresh
                )
            );
        case handlers.GENERATE_FANDECK_PREVIEW:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (
                response.data === undefined ||
                response.data.mimeType === undefined ||
                response.data.data === undefined
            ) {
                return [
                    {
                        type: actionTypes.IMAGE_STORE_UPDATE
                    }
                ];
            }

            if (state.formula[tabId].fandeck !== null) {
                window.imageStore.addFandeckImage(state.formula[tabId].fandeck.id, {
                    type: response.data.mimeType,
                    img: response.data.data
                });
            }

            return [
                {
                    type: actionTypes.SAVE_FANDECK_COLOR_COUNT,
                    payload: {
                        tabId: tabId,
                        colorCount: response.data.colorCount
                    }
                },
                {
                    type: actionTypes.IMAGE_STORE_UPDATE
                }
            ];
        case handlers.GET_ALL_COLORANTS_FOR_BIP:
            if (!responseHelper.isGetAllColorantsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SET_COLORANT_PANEL_COLORANT_LIST,
                    payload: {
                        tabId: tabId,
                        colorantList: modelHelper.mapColorantsToObjects(response.data.colorantList)
                    }
                }
            ];
        case handlers.GET_FORMULA_CIF:
            if (!responseHelper.isColorInFandeckValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            if (response.data) {
                return [
                    {
                        type: actionTypes.SAVE_FORMULA_CIF_RGB,
                        payload: {
                            tabId: tabId,
                            code: response.data.code,
                            rgb: response.data.rgb
                        }
                    }
                ];
            }

            return [];
        case handlers.GET_CLOSEST_COLOR:
            if (!responseHelper.isBrowseColorsFormatValid(response)) {
                return [
                    {
                        type: actionTypes.NAVIGATION_CLOSE_MODAL,
                        payload: {
                            type: componentTypes.LOADING_MODAL
                        }
                    },
                    messageHelper.getInvalidFormatMessage(response)
                ];
            }

            if (state.formula[tabId] === undefined) {
                return [
                    {
                        type: actionTypes.NAVIGATION_CLOSE_MODAL,
                        payload: {
                            type: componentTypes.LOADING_MODAL
                        }
                    }
                ];
            }

            let closestColorsRequests = [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.LOADING_MODAL
                    }
                }
            ];

            let closestColors = modelHelper.mapClosestColorsToObjects(response.data);

            if (closestColors.length === 0) {
                return [
                    ...closestColorsRequests,
                    messageHelper.getInfoMessageAction("flashMessage.competitiveSearchEmpty")
                ];
            }

            if (closestColors.length === 1 && state.login.loggedUser.canNotEdit(resources.COMPONENT_MATCHING_TAB)) {
                return [
                    {
                        type: actionTypes.SELECT_CLOSEST_COLOR_AND_FANDECK,
                        payload: {
                            tabId: tabId,
                            product: null,
                            fandeck: closestColors[0].fandeck,
                            color: closestColors[0].color,
                            delta: closestColors[0].delta
                        }
                    },
                    ...closestColorsRequests
                ];
            }

            return [
                ...closestColorsRequests,
                {
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: tabId,
                        type: componentTypes.CLOSEST_COLORS_MODAL,
                        params: {
                            original: state.formula[tabId].color,
                            closest: closestColors
                        }
                    }
                }
            ];
        case handlers.GET_CLOSEST_COLOR_WITH_PRICES:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [
                    {
                        type: actionTypes.NAVIGATION_CLOSE_MODAL,
                        payload: {
                            type: componentTypes.LOADING_MODAL
                        }
                    },
                    messageHelper.getInvalidFormatMessage(response)
                ];
            }

            if (
                state.formula[tabId] === undefined ||
                state.formula[tabId].product === null ||
                state.formula[tabId].fandeck === null ||
                state.formula[tabId].color === null ||
                state.formula[tabId].package === null
            ) {
                return [
                    {
                        type: actionTypes.NAVIGATION_CLOSE_MODAL,
                        payload: {
                            type: componentTypes.LOADING_MODAL
                        }
                    }
                ];
            }

            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.LOADING_MODAL
                    }
                },
                {
                    type: actionTypes.NAVIGATION_OPEN_MODAL,
                    payload: {
                        tabId: tabId,
                        type: componentTypes.CHEAPER_COLORS_MODAL,
                        params: {
                            product: state.formula[tabId].product,
                            fandeck: state.formula[tabId].fandeck,
                            color: state.formula[tabId].color,
                            package: state.formula[tabId].package,
                            margin: state.formula[tabId].margin,
                            colorList: modelHelper.mapClosestColorsWithPricesToObjects(response.data)
                        }
                    }
                }
            ];
        case handlers.RELOAD_CLOSEST_COLOR_WITH_PRICES:
            if (!responseHelper.isSearchDataFormatValid(response)) {
                return [
                    {
                        type: actionTypes.NAVIGATION_SET_MODAL_PARAMS,
                        payload: {
                            tabId: tabId,
                            type: componentTypes.CHEAPER_COLORS_MODAL,
                            params: {
                                colorList: []
                            }
                        }
                    },
                    messageHelper.getInvalidFormatMessage(response)
                ];
            }

            return [
                {
                    type: actionTypes.NAVIGATION_SET_MODAL_PARAMS,
                    payload: {
                        tabId: tabId,
                        type: componentTypes.CHEAPER_COLORS_MODAL,
                        params: {
                            colorList: modelHelper.mapClosestColorsWithPricesToObjects(response.data)
                        }
                    }
                }
            ];
        case handlers.GET_CLOSEST_COLOR_FOR_MISSING_FORMULA:
            if (!responseHelper.isBrowseColorsFormatValid(response)) {
                return [
                    {
                        type: actionTypes.SET_CLOSEST_COLORS_FOR_MISSING_FORMULA,
                        payload: {
                            tabId: tabId,
                            colorList: []
                        }
                    },
                    messageHelper.getInvalidFormatMessage(response)
                ];
            }

            return [
                {
                    type: actionTypes.SET_CLOSEST_COLORS_FOR_MISSING_FORMULA,
                    payload: {
                        tabId: tabId,
                        colorList: modelHelper.mapClosestColorsToObjects(response.data)
                    }
                }
            ];
        case handlers.GET_FORMULA_CIF_DATA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            if (response.data === undefined || response.data === null) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_FORMULA_SPECTRAL_DATA,
                    payload: {
                        tabId: tabId,
                        spectralData: modelHelper.mapSpectralDataToObject(
                            response.data.colorInFandeck.rgbTuple,
                            response.data.colorInFandeckData.lab,
                            response.data.colorInFandeckData.xyz,
                            response.data.colorInFandeck.rgb,
                            modelHelper.formatReflData(response.data.colorInFandeckData.reflData)
                        )
                    }
                }
            ];
        case handlers.GET_BUILDING_SITES:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.MAIN_TAB_SAVE_BUILDING_SITES,
                    payload: {
                        tabId: tabId,
                        buildingSiteList: response.data
                    }
                }
            ];
        case handlers.GET_BUILDING_SITES_WITH_OFFSET:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.MAIN_TAB_SAVE_BUILDING_SITES_WITH_OFFSET,
                    payload: {
                        tabId: tabId,
                        buildingSiteList: response.data
                    }
                }
            ];
        case handlers.GET_FORMULA_VALIDATION_ERRORS:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FORMULA_VALIDATION,
                    payload: {
                        tabId: tabId,
                        validation: modelHelper.mapFormulaValidationErrorsToObject(
                            response.data,
                            state.formula[tabId] !== undefined && state.formula[tabId].formula !== null
                                ? state.formula[tabId].formula.validationAll
                                : rcc.RCC_VALIDATION_OK,
                            state.settings.validateTotalCntAmounts,
                            state.settings.validateOverfill,
                            state.settings.validateMinDosableAmount,
                            state.settings.colorantBatchNumberLogic !== settings.COLORANT_BATCH_NUMBER_LOGIC_DISABLED,
                            state.settings.validateColorantBaseRules,
                            state.settings.colorantBatchForMultipleCans
                        )
                    }
                }
            ];
        case handlers.GET_COLOR_IN_FANDECK:
            if (!responseHelper.isColorInFandeckValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            if (response.data) {
                return [
                    {
                        type: actionTypes.SAVE_COLOR_IN_FANDECK_RGB,
                        payload: {
                            tabId: tabId,
                            code: response.data.code,
                            rgb: response.data.rgb
                        }
                    }
                ];
            }

            return [];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
